import React, { useEffect, useState } from "react";
import {
  Typography,
  Table,
  TableBody,
  TableRow,
  TableCell,
  TextField,
  Select,
  MenuItem,
} from "@mui/material";

const tdLabelSx = {
  width: 180,
  bgcolor: "#f3f3f3",
  borderRight: "1px solid #e0e0e0",
  color: "#333",
  fontWeight: 600,
};

const tdFieldSx = { p: 1 };

const InfoMotion = ({ onChange }) => {
  const [data, setData] = useState({
    bodega: "PRINCIPAL",
    tipo: "INGRESO",
    fecha: "",
    referencia: "",
    descripcion: "",
    responsable_nombre: "",
    responsable_email: "",
  });

  useEffect(() => {
    (async () => {
      try {
        const r = await fetch("/inventario/defaults/", { credentials: "include" });
        const j = await r.json();
        if (r.ok) {
          setData((prev) => ({
            ...prev,
            fecha: j.fecha || "",
            responsable_nombre: j.responsable_nombre || "",
            responsable_email: j.responsable_email || "",
          }));
        }
      } catch {}
    })();
  }, []);

  useEffect(() => {
    onChange?.((prev) => ({
      ...(prev || {}),
      inventario: { ...data },
    }));
  }, [data, onChange]);

  const h = (f) => (e) => setData((p) => ({ ...p, [f]: e.target.value }));

  return (
    <>
      <Typography variant="h6" sx={{ fontWeight: 700, mb: 2 }}>
        Información del Movimiento
      </Typography>

      <Table>
        <TableBody>
          <TableRow>
            <TableCell sx={tdLabelSx}>Bodega:</TableCell>
            <TableCell sx={tdFieldSx} colSpan={3}>
              <Select value="PRINCIPAL" size="small" disabled sx={{ width: 280 }}>
                <MenuItem value="PRINCIPAL">Bodega principal</MenuItem>
              </Select>
            </TableCell>
          </TableRow>

          <TableRow>
            <TableCell sx={tdLabelSx}>Fecha:</TableCell>
            <TableCell sx={tdFieldSx} colSpan={3}>
              <TextField value={data.fecha} onChange={h("fecha")} size="small" sx={{ width: 220 }} />
            </TableCell>
          </TableRow>

          <TableRow>
            <TableCell sx={tdLabelSx}>Movimiento:</TableCell>
            <TableCell sx={tdFieldSx} colSpan={3}>
              <Select value={data.tipo} onChange={h("tipo")} size="small" sx={{ width: 280 }}>
                <MenuItem value="INGRESO">Ingreso</MenuItem>
                <MenuItem value="SALIDA">Salida</MenuItem>
              </Select>
            </TableCell>
          </TableRow>

          <TableRow>
            <TableCell sx={tdLabelSx}>Referencia:</TableCell>
            <TableCell sx={tdFieldSx} colSpan={3}>
              <TextField value={data.referencia} onChange={h("referencia")} size="small" sx={{ width: 350 }} />
            </TableCell>
          </TableRow>

          <TableRow>
            <TableCell sx={tdLabelSx}>
              Descripción <span style={{ color: "red" }}>*</span>
            </TableCell>
            <TableCell sx={tdFieldSx} colSpan={3}>
              <TextField
                value={data.descripcion}
                onChange={h("descripcion")}
                size="small"
                fullWidth
                required
              />
            </TableCell>
          </TableRow>

          <TableRow>
            <TableCell sx={tdLabelSx}>Responsable:</TableCell>
            <TableCell sx={tdFieldSx} colSpan={3}>
              <TextField
                value={data.responsable_nombre || data.responsable_email}
                size="small"
                fullWidth
                InputProps={{ readOnly: true }}
              />
            </TableCell>
          </TableRow>
        </TableBody>
      </Table>
    </>
  );
};

export default InfoMotion;

